import { render, staticRenderFns } from "./FakeChoice.vue?vue&type=template&id=a18d8a4e&"
import script from "./FakeChoice.vue?vue&type=script&lang=js&"
export * from "./FakeChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports